import { getLocalSetting } from './LocalEnv';

const LOCAL_OVERRIDDEN = 'true';
const LOCAL_NOT_OVERRIDDEN = 'false';
const LOCAL = 'local';
const APP = /app.hubspot(qa)?.com/i;
const TOOLS = /tools.hubteam(qa)?.com/i;

const windowOrigin =
  window.location.origin || // IE
  `${window.location.protocol}//${window.location.hostname}${
    window.location.port ? `:${window.location.port}` : ''
  }`;

const getLocalEnvSetting = (name: string) => getLocalSetting(name, LOCAL);

/**
 * Returns the Bend Worktree prefix if the current page is served from one,
 * or an empty string otherwise.
 *
 * Bend Worktrees use a fixed hostname shape:
 *     https://<worktree>.local.<domain>.<tld>   (e.g. my-feature.local.hubspotqa.com)
 *
 * So after splitting on `.`, the worktree is always `parts[0]` when
 * `parts[1] === 'local'`.
 */
export const getWorktreePrefix = (
  hostname = window.location.hostname
): string => {
  const worktreeMatch = hostname.match(/^([^.]+)\.local\./);
  return worktreeMatch ? `${worktreeMatch[1]}.` : '';
};

const toLocal = (url: string): string => {
  const worktreePrefix = getWorktreePrefix();
  return url
    .replace(APP, `${worktreePrefix}${LOCAL}.hubspot$1.com`)
    .replace(TOOLS, `${worktreePrefix}${LOCAL}.hubteam$1.com`);
};

export const getOrigin = (url: string): string => {
  if (url.indexOf('//') === 0) {
    url = `${window.location.protocol}${url}`;
  } else if (url.indexOf('/') === 0) {
    return windowOrigin;
  }

  const parts = url.split('://');

  if (parts.length > 1) {
    return `${parts[0]}://${parts[1].split('/')[0]}`;
  } else {
    return windowOrigin;
  }
};

// Allows for a complete local src URL override or using a local instead of app
export const getIFrameSrc = (iFrameName: string, url: string): string => {
  const localEnvSetting = getLocalEnvSetting(iFrameName);

  if (localEnvSetting === LOCAL_NOT_OVERRIDDEN) {
    return url;
  }

  if (localEnvSetting === LOCAL_OVERRIDDEN) {
    return toLocal(url);
  }

  return localEnvSetting || url;
};
